import React from "react";
import { Props } from "./types";

function AddGroupIcon({ className }: Props) {
  const [isHovered, setIsHovered] = React.useState(false);

  return isHovered ? (
    <svg
      className={className}
      viewBox="0 0 39.545 33"
      onMouseLeave={() => setIsHovered(false)}
    >
      <g fill="none" stroke="#ff8e43" strokeWidth="1" strokeDasharray="5">
        <circle cx="16.5" cy="16.5" r="16.5" stroke="none" />
        <circle cx="16.5" cy="16.5" r="16" fill="none" />
      </g>
      <path
        d="M3.466,9.183A2.311,2.311,0,1,0,1.155,6.872,2.313,2.313,0,0,0,3.466,9.183Zm16.177,0a2.311,2.311,0,1,0-2.311-2.311A2.313,2.313,0,0,0,19.643,9.183ZM20.8,10.338H18.487a2.3,2.3,0,0,0-1.628.672,5.282,5.282,0,0,1,2.712,3.95h2.383A1.154,1.154,0,0,0,23.109,13.8V12.649A2.313,2.313,0,0,0,20.8,10.338Zm-9.244,0A4.044,4.044,0,1,0,7.511,6.294,4.042,4.042,0,0,0,11.555,10.338Zm2.773,1.155h-.3a5.584,5.584,0,0,1-4.947,0h-.3a4.161,4.161,0,0,0-4.16,4.16v1.04a1.734,1.734,0,0,0,1.733,1.733h10.4a1.734,1.734,0,0,0,1.733-1.733v-1.04A4.161,4.161,0,0,0,14.328,11.494ZM6.25,11.01a2.3,2.3,0,0,0-1.628-.672H2.311A2.313,2.313,0,0,0,0,12.649V13.8A1.154,1.154,0,0,0,1.155,14.96h2.38A5.3,5.3,0,0,1,6.25,11.01Z"
        transform="translate(4.945 5.573)"
        fill="#ff8e43"
      />
      <path
        d="M7.273,0A7.273,7.273,0,1,1,0,7.273,7.273,7.273,0,0,1,7.273,0Z"
        transform="translate(25 8)"
        fill="#ff8e43"
      />
      <text
        transform="translate(28 19)"
        fill="#fff"
        fontSize="14"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0.7" y="0.8">
          +
        </tspan>
      </text>
    </svg>
  ) : (
    <svg
      className={className}
      viewBox="0 0 39.545 33"
      onMouseEnter={() => setIsHovered(true)}
    >
      <g fill="none" stroke="#b9b9b9" strokeWidth="1" strokeDasharray="5">
        <circle cx="16.5" cy="16.5" r="16.5" stroke="none" />
        <circle cx="16.5" cy="16.5" r="16" fill="none" />
      </g>
      <path
        d="M3.466,9.183A2.311,2.311,0,1,0,1.155,6.872,2.313,2.313,0,0,0,3.466,9.183Zm16.177,0a2.311,2.311,0,1,0-2.311-2.311A2.313,2.313,0,0,0,19.643,9.183ZM20.8,10.338H18.487a2.3,2.3,0,0,0-1.628.672,5.282,5.282,0,0,1,2.712,3.95h2.383A1.154,1.154,0,0,0,23.109,13.8V12.649A2.313,2.313,0,0,0,20.8,10.338Zm-9.244,0A4.044,4.044,0,1,0,7.511,6.294,4.042,4.042,0,0,0,11.555,10.338Zm2.773,1.155h-.3a5.584,5.584,0,0,1-4.947,0h-.3a4.161,4.161,0,0,0-4.16,4.16v1.04a1.734,1.734,0,0,0,1.733,1.733h10.4a1.734,1.734,0,0,0,1.733-1.733v-1.04A4.161,4.161,0,0,0,14.328,11.494ZM6.25,11.01a2.3,2.3,0,0,0-1.628-.672H2.311A2.313,2.313,0,0,0,0,12.649V13.8A1.154,1.154,0,0,0,1.155,14.96h2.38A5.3,5.3,0,0,1,6.25,11.01Z"
        transform="translate(4.945 5.573)"
        fill="#b9b9b9"
      />
      <path
        d="M7.273,0A7.273,7.273,0,1,1,0,7.273,7.273,7.273,0,0,1,7.273,0Z"
        transform="translate(25 8)"
        fill="#b9b9b9"
      />
      <text
        transform="translate(28 19)"
        fill="#fff"
        fontSize="14"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0.7" y="0.8">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddGroupIcon };
